export const VIDEO_ID = "KYN2yDxyY9w";

export const VIDEO_THUMBNAIL_PRIMARY = `https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`;
export const VIDEO_THUMBNAIL_FALLBACK = `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`;
export const VIDEO_EMBED_URL = `https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`;
export const VIDEO_WATCH_URL = `https://www.youtube.com/watch?v=${VIDEO_ID}`;

export const SITE_CONTAINER_MAX = 1280;

export const HERO_ASSEMBLY_TOTAL_MS = 2400;
